module.exports = __webpack_public_path__ + "img/dummy.ca1d1691.jpg";